<template>
    <v-flex xl12>
        <h2>Dicas e novidades <span class="text-title-header"> | Cadastro de dicas e novidades</span></h2>
        <v-divider></v-divider>
        <br/>
        <router-view></router-view>
    </v-flex>
</template>
<script>
export default {
  name: 'news',
  mounted: function () {
    this.$nextTick(function () {

    })
  }
}
</script>
